import { useAppContext } from "Main";
import {
  isAfter,
  isBefore,
  parseISO
} from "date-fns";
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";

export default function AuthGuard() {
  const { state } = useAppContext();
  const { pathname: path } = useLocation();
  let { token, isLoading } = state;

  const tokenExpiry = localStorage.getItem("tokenExpiry");
  const userFound = localStorage.getItem("user");
  const menus = localStorage.getItem("menus");

  // console.log(tokenExpiry);

  const isTokenExpired = (tokenParameter) => {
    if (!tokenParameter) return true;

    const givenDateString = tokenExpiry ? tokenExpiry : "";
    // const givenDateString = "2024-05-23T06:56:04.4759098-04:00";

    // Parse the given date to a Date object
    const givenDate = parseISO(givenDateString);

    // console.log(givenDate);

    // Get the current date
    const currentDate = new Date();
    // console.log(currentDate);

    const isGivenDateFuture = isAfter(givenDate, currentDate);
    const isGivenDatePast = isBefore(givenDate, currentDate);

    try {
      // return tokenExpiry < date;
      return isGivenDatePast;
    } catch (error) {
      console.log(error);
      return true;
    }
  };

  if (isLoading) {
    return "Loading";
  }
  if (token && path == "/login") {
    return <Navigate to={"/"} />;
  }
  if (!token && path != "/login") {
    return <Navigate to={"login"} />;
  }
  if (token && isTokenExpired(token)) {
    localStorage.clear();
    toast.info("Your session is expired, login again.", {
      position: customSettings.toastPosition,
      autoClose: customSettings.toastClose,
    });
    return <Navigate to={"login"} />;
  }
  if (!userFound) {
    localStorage.clear();

    return <Navigate to={"login"} />;
  }

  // // **Extract allowed routes after ensuring data is loaded**
  // const allowedRoutes = nestedMenuItems?.flatMap((menu) => [
  //   menu.url.startsWith("/") ? menu.url : `/${menu.url}`,
  //   ...(menu.children
  //     ? menu.children.map((child) =>
  //         child.url.startsWith("/") ? child.url : `/${child.url}`
  //       )
  //     : []),
  // ]).filter(Boolean); // Ensure no null/undefined values

  // // **Prevent navigation before allowedRoutes is computed**
  // if (!allowedRoutes.length) {
  //   return <div>Loading menu...</div>; // Ensure routes are loaded before checking
  // }

  // // **Redirect to unauthorized page if the path is not in allowedRoutes**
  // if (!allowedRoutes.includes(path)) {
  //   return <Navigate to="/unauthorized" />;
  // }

  // if (!menus) {
  //   localStorage.clear();
  //   return <Navigate to={"login"} />;
  // }
  return <Outlet />;
}
